import { useLocation, useHistory } from 'react-router-dom';
import * as qs from 'qs';
import { sessionKey } from '../modules/app';
import { duplicateSessionValue } from './localStorage';

export const useQueryParams = () => {
  const location = useLocation();
  return qs.parse(location.search, { ignoreQueryPrefix: true });
};

export const makeQueryStrings = (params) => {
  const search = qs.stringify(params);
  return search ? `${search}` : '';
};

// export const makeQueryStringsWithSessionKey = (params) => {
//   const search = qs.stringify({ ...params, k: sessionKey });
//   return search ? `${search}` : '';
// };

export const makeQueryStringsWithDuplicatedSessionKey = (params) => {
  const newSessionKey = duplicateSessionValue(sessionKey);
  const search = qs.stringify({ ...params, k: newSessionKey });
  return search ? `${search}` : '';
};

// cannot be called inside useEffect
export const makeQueryStringsFromCurrentUrl = (params) => {
  const query = useQueryParams();
  return makeQueryStrings({ ...query, ...params });
};

// cannot be called inside useEffect
export const addQueryParamsToCurrentUrl = (params) => {
  const history = useHistory();
  const search = makeQueryStringsFromCurrentUrl(params);
  return history.push({ search });
};

export const makeAdditionalParamsPlanList = (hotelId) => {
  return  {
    h: hotelId,
  };
};

export const makeAdditionalParamsPlanDetail = (planId, roomTypeId) => {
  return  {
    p: planId,
    rt: roomTypeId,
  };
};
